module.exports = __webpack_public_path__ + "static/media/quality-slide1.914126b4.jpg";